
import {Vue, Component} from 'vue-property-decorator';
import {queryOriginalDetail} from "@/api/invoice/index";

@Component({name: 'OriginInfo'})
export default class OriginInfo extends Vue {
  private showDialog = false;
  private originInfo: any = {};

  public async openDialog(row: any) {
    let params: any;
    if (row.replaceStatus.desc !== '空') {
      params = {id: row.originalFactoryInvoiceId};
    } else {
      params = {id: row.id};
    }
    this.originInfo = await queryOriginalDetail(params) as any;
    this.showDialog = true;
  }
}
